// --------------------------------------------------------
// ExamsTab - ExamsTab
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Search } from "@mui/icons-material";
import { OutlinedInput, Button, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CareLineDropdown from "../../../../components/dropdown/CareLineDropdown";
import ExamCard from "../../../../components/ExamCard/ExamCard";
import {
  H1,
  Text,
} from "../../../../components/UI/generalLayout/Layout.styled";
import { Spacer } from "../../../../components/UI/spacer/spacer";
import Colors from "../../../../constants/Colors";
import {
  PersonExamService,
  PersonExamType,
} from "../../../../core/http/service/PersonExam";
import { Paths } from "../../../../enums/Paths";
import useResponsiveInfo from "../../../../hooks/useResponsiveInfo";
import { ILogin } from "../../../../store/reducers/login";
import { getYearBeforeToday } from "../../../../utils/date.utils";
import { CompanyListContainer } from "../../../company/CompanyList.styled";
import { ExamsContainers, ExamsHeader } from "../../../exams/Exams.style";
import {
  SearchContainer,
  SolidButton,
} from "../attendanceRecord/AttendanceRecord.styled";
import {
  ContainerExamsTab,
  HeaderExamsTab,
} from "./ExamsTab.styled";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// ExamsTab INTERFACE
// --------------------------------------------------------

interface IExamsTab {
  pessoa: any;
}

const years = getYearBeforeToday(5);

interface YearLabel {
  nome: string;
  id: string;
}

const yearsLabels = years.map<YearLabel>((value) => ({
  nome: value,
  id: value,
}));

const allValue = [{ nome: "Todos", id: 0 }];
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const ExamsTab = ({ pessoa }: IExamsTab) => {
  // --------------------------------------------------------
  // ExamsTab PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { state } = useLocation();
  const { id } = (state as any) ?? {};
  const navigate = useNavigate();
  const { isMobile } = useResponsiveInfo();
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any[]>([]);
  const [selectedYear, setSelectedYear] = useState<YearLabel>();
  const [selectedNameSearch, setSelectedNameSearch] = useState("");
  const [exams, setExams] = useState<PersonExamType[]>([]);

  const { userInfo } = useSelector((state: { login: ILogin }) => state.login);
  const years = getYearBeforeToday(5);
  const { currentProfile }: any = useSelector((state: any) => state.login);
  const acessoProntuario = useSelector((state: any)=> state.person.acessoProntuario)

  const yearsLabels = years.map<YearLabel>((value) => ({
    nome: value,
    id: value,
  }));
  
  // --------------------------------------------------------
  useEffect(() => {
    const service = new PersonExamService();
    if (userInfo) {
      setLoading(true);
      const selectedAll =
        selectedYear?.nome !== "Todos" ? selectedYear?.nome : "";

      service
        .getExams({
          id: pessoa.idPessoa,
          Nome: selectedNameSearch,
          Ano: selectedAll,
        })
        .then(({ data: { data } }) => {
          setExams(data);
        })
        .catch((error) => {
          setExams([]);
          setError([error]);
        })
        .finally(() => setLoading(false));
    }
  }, [selectedNameSearch, userInfo, selectedYear?.nome]);

  const onClickSearch = () => {
    setSelectedNameSearch(search);
  };

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <ContainerExamsTab>
      <HeaderExamsTab>
        <H1>Exames</H1>
        {
          !acessoProntuario ? 
            <SolidButton
            width={21}
            style={{ height: "20px" }}
            color={Colors.SPM600}
            onClick={() => navigate(Paths.RegistrarExame, { state: { pessoa: pessoa }})}
          >
            Registrar Exame
          </SolidButton>
          :
           ''
        }

      </HeaderExamsTab>
      <Spacer top={20} />
      <SearchContainer>
        <OutlinedInput
          style={{
            borderRadius: "10px",
            width: isMobile ? "100%" : "450px",
          }}
          id="outlined-adornment-amount"
          endAdornment={
            <Button onClick={onClickSearch}>
              <Search />
            </Button>
          }
          label=""
          placeholder="Buscar exames"
          value={search}
          onChange={(event: any) => {
            setSearch(event.target.value);
          }}
        />
        <CareLineDropdown
          value={selectedYear}
          onChange={setSelectedYear}
          items={yearsLabels}
          disabled={false}
          backgroundColor={Colors.SPM50}
          textColor={Colors.SPM600}
          placeholder="Selecione o ano"
          containerStyle={{
            width: isMobile ? "100%" : "25%",
          }}
          allValue={allValue}
        />
      </SearchContainer>
      <Spacer top={30} />
      <ExamsContainers>
        <ExamsHeader>
          <Text bold>Nome do exame</Text>
          <Text bold>Data</Text>
        </ExamsHeader>
        <CompanyListContainer isMobile={isMobile}>
          {loading ? (
            <CircularProgress />
          ) : exams.length > 0 && id ? (
            exams
              .filter((d: any) => d.id === id)
              .map((data) => {
                return (
                  <>
                    <Spacer top={10} />

                    <ExamCard
                      key={data.id}
                      data={data}
                      filter={true}
                      onSearchEqual={(value) => {
                        setSelectedNameSearch(value);
                        setSearch(value);
                      }}
                    />
                  </>
                );
              })
          ) : exams.length > 0 ? (
            exams.map((data) => {
              return (
                <>
                  <Spacer top={10} />

                  <ExamCard
                    key={data.id}
                    data={data}
                    onSearchEqual={(value) => {
                      setSelectedNameSearch(value);
                      setSearch(value);
                    }}
                  />
                </>
              );
            })
          ) : (
            <Text>Nenhum resultado encontrado</Text>
          )}
        </CompanyListContainer>
      </ExamsContainers>
    </ContainerExamsTab>
  );
  // --------------------------------------------------------
};

export default ExamsTab;
